<template>
    <footer>
      <div class="footer-area ptb--50">
	<div class="container">
		<div class="footer-content">
			<p>
        <span v-html="$tm('footer.text1')"></span>
        <a v-if="lang == 'zh'" href="https://beian.miit.gov.cn" target="_blank" style="color: #fff;font-size: 16px;">{{ $tm('footer.icpText') }}</a> 
        &nbsp;&nbsp;&nbsp;<a :href="$tm('footer.policyUrl')" target="_blank" style="color: #fff;font-size: 16px;">{{ $tm('footer.policy') }}</a>
      </p>
		</div>  
	</div>
</div>
    </footer>
  </template>
  
  <script>
  import { useI18n } from 'vue-i18n';

  export default {
    name: "Footer",
    setup(){
      const { tm, locale } = useI18n();
      const lang = locale.value;
      
      const data = {
        "cn": {
          "text1": "Copyright &copy; 2024.Walk Play All rights reserved.&nbsp;&nbsp;&nbsp;ICP备案号：",
          "icpText": "粤ICP备20022174号",
          "policyUrl": "/policy",
          "policy": "用户协议及隐私条款"
        },
        "en": {
          "text1": "Copyright © 2024.Walk Play All rights reserved.&nbsp;&nbsp;&nbsp;ICP",
          "icpText": "粤ICP备20022174号",
          "policyUrl": "/policy",
          "policy": "Agreement & Privacy Policy"
        }
      }

      return {tm,lang};
    }
  };
  </script>
  
  <style scoped>
  /* 针对底部样式 */
  </style>
  